import React, {useEffect} from "react";
import Modal from "../index";
import {CancelButton, FlexContainer, Img, Loader, SubmitButton, Text} from "../../../design";

type Props = {
  isOpen: boolean,
  header: string,
  body: string,
  icon: string,
  showIcon: boolean,
  iconDocument: Document,
  showCancelBtn: boolean,
  cancelBtnText: string,
  showSubmitBtn: boolean,
  submitBtnText: string,
  hideBtn: boolean,
  cancel: Function,
  submit: Function
}

const AlertModal = (props : Props) => {
  const { isOpen, icon, header, body, cancel, submit, hideBtn, showCancelBtn, showSubmitBtn,
    submitBtnText, cancelBtnText, showIcon } = props;
  useEffect( () => {
    document.body.style.overflowY = 'auto';
    if(props.isOpen) { document.body.style.overflow = 'hidden';}
  }, [isOpen]);
  return (
    <Modal isOpen={isOpen}>
      <FlexContainer
        height="400px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
        backdropFilter='none'
        borderRadius='4px'
        backgroundColor="#f2f5f8"
        textAlign='center'
        alignContent='none'
        paddingTop="10px"
        paddingLeft="10px"
        paddingRight="10px"
        paddingBottom="10px"
      >
        <>
          {showIcon && <div>
            {icon ? <Img width='108px' height='108px' paddingBottom='25px' src={icon} /> : <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '100%',
                position: 'relative',
                margin: '20px auto',
              }}
            >
              <Loader/>
            </div>}
          </div>}
          <Text
            fontSize="20px"
            fontWeight='600'
          >
            {header}
          </Text>
          <Text fontSize="16px" textAlign='center'>{body}</Text>
          {!hideBtn && <FlexContainer
            justifyContent="center"
            alignItems="center"
            width="100%"
          >
            {showCancelBtn && <CancelButton
              onClick={cancel}
              type="button"
            >{cancelBtnText || "Cancel"}</CancelButton>}
            {showSubmitBtn && <SubmitButton
              onClick={submit}
              type="button"
            >{submitBtnText || "Submit"}</SubmitButton>}
          </FlexContainer>}
        </>
      </FlexContainer>
    </Modal>
  )
};

export default AlertModal;
